import {
    Box,
    Button,
    Flex,
    FormControl,
    FormLabel,
    IconButton,
    Input,
    Select,
    Text,
    Textarea,
    VStack,
    keyframes,
    useColorModeValue,
} from '@chakra-ui/react';
import { MdAdd, MdDelete, MdEdit } from 'react-icons/md';
import Card from 'components/card/Card';
import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { TOOL_SCHEMA_OPEN_AI, TOOL_SCHEMA_DEEPGRAM } from 'utils/data';
import { createAPIEndPoint } from 'config/api/api';
import toast from 'react-hot-toast';
import ToolResultModal from './ToolResultModal';
import DeleteModal from 'components/deleteModal/DeleteModal';
import { RepeatIcon } from '@chakra-ui/icons';


const ToolSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string()
        .test('is-json', 'Description must be valid JSON.', value => {
            try {
                JSON.parse(value);
                return true;
            } catch {
                return false;
            }
        })
        .required('Description is required'),

    service: Yup.string().required('Service type is required'),
});


const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;


const ToolForm = ({ selectedTool, mode, onSubmit, onDelete, openDeleteModal }) => {
    const [serviceType, setServiceType] = useState(selectedTool?.service || '');
    const [defaultSchema, setDefaultSchema] = useState('');
    const [testing, setTesting] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [testResult, setTestResult] = useState({ isSuccess: false, message: '' });

    const ServiceWatcher = ({ selectedTool }) => {
        const { values, setFieldValue } = useFormikContext();

        useEffect(() => {
            if (!selectedTool && values.service) {
                const schema =
                    values.service === "deepgram"
                        ? JSON.stringify(TOOL_SCHEMA_DEEPGRAM.tool.function, null, 2)
                        : JSON.stringify(TOOL_SCHEMA_OPEN_AI.tool.function, null, 2);
                setFieldValue("description", schema);
            }
        }, [values.service, selectedTool, setFieldValue]);

        return null;
    };


    // const handleTestTool = async () => {
    //     setTesting(true);
    //     try {
    //         const parsed = JSON.parse(selectedTool?.tool?.function
    //             ? JSON.stringify(selectedTool.tool.function)
    //             : '{}');

    //         const service = selectedTool?.service || "openai"; // fallback if not defined

    //         const endpoint =
    //             service === "deepgram"
    //                 ? "test_deepgram_tool_format"
    //                 : "test_tool_format";

    //         const payload = {
    //             tool: {
    //                 type: "function",
    //                 function: parsed,
    //             },
    //         };

    //         const response = await createAPIEndPoint(endpoint).create(payload);

    //         setTestResult({
    //             isSuccess: true,
    //             message: response?.data?.message || "Tool executed successfully.",
    //         });
    //         setModalOpen(true);
    //     } catch (err) {
    //         setTestResult({
    //             isSuccess: false,
    //             message:
    //                 err?.response?.data?.error || "Something went wrong during tool testing.",
    //         });
    //         setModalOpen(true);
    //     } finally {
    //         setTesting(false);
    //     }
    // };



    return (
        <Box p={2} bg="white" borderRadius="md">
            <Formik
                initialValues={{
                    name: selectedTool?.name || '',
                    description: selectedTool?.tool?.function
                        ? JSON.stringify(selectedTool.tool.function, null, 2)
                        : JSON.stringify(TOOL_SCHEMA_OPEN_AI.tool.function, null, 2),
                    service: selectedTool?.service || 'openai',
                }}
                validationSchema={ToolSchema}
                onSubmit={(values, actions) => {
                    onSubmit(values);
                    actions.setSubmitting(false);
                }}
                enableReinitialize
            >
                {({ errors, touched, isSubmitting, values, handleChange, handleBlur, setFieldError, setFieldValue }) => {


                    return (
                        <>
                            <ServiceWatcher selectedTool={selectedTool} />

                            <Flex justifyContent="space-between" alignItems="center" mb={4}>
                                <Text fontSize="xl" fontWeight="bold" color="brand.500">
                                    {mode === 'edit' ? 'Edit Tool' : 'Create New Tool'}
                                </Text>

                                {/* {mode === 'edit' && ( */}
                                {/* <Button
                    colorScheme="teal"
                    size="sm"
                    borderRadius={12}
                    variant="outline"
                    isLoading={testing}
                    loadingText="Testing..."
                    onClick={handleTestTool}
                >
                    Test Tool
                </Button> */}
                                {/* <Button
                                    colorScheme="teal"
                                    size="sm"
                                    borderRadius={12}
                                    variant="outline"
                                    isLoading={testing}
                                    loadingText="Testing..."
                                    onClick={async () => {
                                        setTesting(true);
                                        try {
                                            // const parsed = JSON.parse(values.description || '{}');
                                            const service = values.service || "openai";
                                            const endpoint =
                                                service === "deepgram"
                                                    ? "test_deepgram_tool_format"
                                                    : "test_tool_format";

                                            const payload = {
                                                tool: {
                                                    type: "function",
                                                    // function: values.description,
                                                    function: typeof values.description === 'string'
                                                        ? JSON.parse(values.description)
                                                        : values.description,

                                                },
                                            };

                                            const response = await createAPIEndPoint(endpoint).create(payload);

                                            setTestResult({
                                                isSuccess: true,
                                                message: response?.data?.message || "Tool executed successfully.",
                                            });
                                            setModalOpen(true);
                                        } catch (err) {
                                            const errorMsg =
                                                err?.response?.data?.error || "Invalid JSON or tool execution failed.";

                                            // ✅ Show error below Description field
                                            if (err?.response?.data?.error) {
                                                setFieldError("description", errorMsg);
                                            }

                                            setTestResult({
                                                isSuccess: false,
                                                message: errorMsg,
                                            });
                                            setModalOpen(true);
                                        } finally {
                                            setTesting(false);
                                        }
                                    }}
                                >
                                    Test Tool
                                </Button> */}
                                <Button
                                    colorScheme="whatsapp"
                                    size="sm"
                                    borderRadius="xl"
                                    leftIcon={
                                        <RepeatIcon
                                            animation={testing ? `${spin} 1s linear infinite` : undefined}
                                        />
                                    } variant="solid"
                                    isLoading={testing}
                                    loadingText="Testing..."
                                    onClick={async () => {
                                        setTesting(true);
                                        try {
                                            // const parsed = JSON.parse(values.description || '{}');
                                            const service = values.service || "openai";
                                            const endpoint =
                                                service === "deepgram"
                                                    ? "test_deepgram_tool_format"
                                                    : "test_tool_format";

                                            const payload = {
                                                tool: {
                                                    type: "function",
                                                    // function: values.description,
                                                    function: typeof values.description === 'string'
                                                        ? JSON.parse(values.description)
                                                        : values.description,

                                                },
                                            };

                                            const response = await createAPIEndPoint(endpoint).create(payload);

                                            setTestResult({
                                                isSuccess: true,
                                                message: response?.data?.message || "Tool executed successfully.",
                                            });
                                            setModalOpen(true);
                                        } catch (err) {
                                            const errorMsg =
                                                err?.response?.data?.error || "Invalid JSON or tool execution failed.";

                                            // ✅ Show error below Description field
                                            if (err?.response?.data?.error) {
                                                setFieldError("description", errorMsg);
                                            }

                                            setTestResult({
                                                isSuccess: false,
                                                message: errorMsg,
                                            });
                                            setModalOpen(true);
                                        } finally {
                                            setTesting(false);
                                        }
                                    }}
                                >
                                    Test Tool
                                </Button>

                                {/* )} */}

                            </Flex>



                            <Form>

                                <FormControl isInvalid={touched.service && errors.service} mb={3}>
                                    <FormLabel>Service Type</FormLabel>
                                    <Select
                                        name="service"
                                        value={values.service}
                                        onChange={(e) => {
                                            handleChange(e);
                                            setServiceType(e.target.value); // update state to trigger useEffect
                                        }}
                                        onBlur={handleBlur}
                                        fontSize="sm"
                                    // fontWeight="500"
                                    // variant="auth"
                                    // placeholder="Select service type"
                                    >
                                        <option value="openai">Open AI</option>
                                        <option value="deepgram">Deepgram</option>
                                    </Select>
                                    {touched.service && errors.service && (
                                        <Text color="red.500" fontSize="sm">{errors.service}</Text>
                                    )}
                                </FormControl>

                                <FormControl mb={4}>
                                    <FormLabel>Tool Name</FormLabel>

                                    <Field as={Input} fontSize="sm" name="name" placeholder="Enter tool name" />
                                    {errors.name && touched.name && (
                                        <Text color="red.500" fontSize="sm">{errors.name}</Text>
                                    )}
                                </FormControl>

                                <FormControl mb={4}>
                                    <FormLabel>Description</FormLabel>
                                    <Textarea
                                        fontSize="sm"
                                        name="description"
                                        value={
                                            typeof values.description === 'string'
                                                ? values.description
                                                : JSON.stringify(values.description, null, 2)
                                        }

                                        onChange={(e) => {
                                            try {
                                                const parsed = JSON.parse(e.target.value); // if valid JSON
                                                setFieldValue("description", parsed);
                                            } catch {
                                                setFieldValue("description", e.target.value); // keep raw string
                                            }
                                        }}

                                        onBlur={handleBlur}
                                        rows={14}
                                        resize="vertical"
                                        fontFamily="mono"
                                        borderTopRightRadius="0px"
                                        borderBottomRightRadius="0px"
                                    />
                                    {errors.description && touched.description && (
                                        <Text color="red.500" fontSize="sm">
                                            {errors.description}
                                        </Text>
                                    )}
                                </FormControl>



                                <Flex mt={4} gap={2} direction={{ base: 'column', sm: 'row' }}>
                                    <Button
                                        fontSize="sm"
                                        type="submit"
                                        colorScheme="brand"
                                        isLoading={isSubmitting}
                                    >
                                        {mode === 'edit' ? 'Update Tool' : 'Create Tool'}
                                    </Button>
                                    {mode === 'edit' && (
                                        <Button
                                            fontSize="sm"
                                            colorScheme="red"
                                            // variant="outline"
                                            // onClick={() => onDelete(selectedTool.id)}
                                            onClick={() => openDeleteModal(selectedTool)}

                                        >
                                            Delete Tool
                                        </Button>
                                    )}
                                </Flex>
                            </Form>
                        </>
                    )
                }}
            </Formik>

            <ToolResultModal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                isSuccess={testResult.isSuccess}
                message={testResult.message}
            />
        </Box>
    );
};





export default function ToolsPanel({ tools, fetchAgain }) {

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [selectedTool, setSelectedTool] = useState(null);
    // const [mode, setMode] = useState(null); // 'edit' or 'create'
    const [mode, setMode] = useState("create"); // 'edit' or 'create'

    const openDeleteModal = (tool) => {
        setItemToDelete(tool);
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        setItemToDelete(null);
    };

    const confirmDelete = async () => {
        if (!itemToDelete) return;
        await handleDeleteTool(itemToDelete.id);
        closeDeleteModal();
    };


    const handleSelectTool = (tool) => {
        setSelectedTool(tool);
        setMode('edit');
    };

    const handleCreateTool = () => {
        setSelectedTool(null);
        setMode('create');
    };

    const textColor = useColorModeValue('gray.800', 'gray.800');

    const handleSubmit = async (values) => {
        try {
            // const parsedFunction = typeof values.description === 'string'
            //     ? JSON.parse(values.description)
            //     : values.description;


            const parsedFunction = JSON.parse(values.description);

            const payload = {

                service: values.service,
                name: values.name,
                tool: {
                    type: 'function',
                    function: parsedFunction,
                },
            };

            if (mode === 'edit' && selectedTool?.id) {
                await createAPIEndPoint('tools/').update(selectedTool.id, payload);
                toast.success('Tool updated successfully!');
            } else {
                await createAPIEndPoint('tools').create(payload);
                toast.success('Tool created successfully!');
            }

            fetchAgain?.(); // Refresh the list
            setSelectedTool(null);
            setMode("create");
        } catch (err) {
            console.error('Submit error:', err);
            toast.error(
                err?.response?.data?.error || 'Invalid function schema or failed to save.'
            );
        }
    };

    const handleDeleteTool = async (id) => {
        try {
            await createAPIEndPoint('tools/').delete(id);
            toast.success('Tool deleted successfully!');
            fetchAgain?.();
            if (selectedTool?.id === id) {
                setSelectedTool(null);
                setMode('create');
            }
        } catch (err) {
            console.error(err);
            toast.error(
                err?.response?.data?.error || 'Failed to delete the tool.'
            );
        }
    };




    return (
        <Card>
            <Flex
                w="100%"
                direction={{ base: "column", lg: "row" }}
                gap={4}
            >
                {/* Left panel - 30% */}
                <Box
                    w={{ base: "100%", lg: "30%" }}
                    p={4}
                    bg="white"
                    borderRadius="md"
                    boxShadow="xs"
                >
                    <Flex justify="space-between" align="center" mb={4}>
                        <Text
                            color={textColor}
                            fontSize="24px"
                            fontWeight="700"
                            lineHeight="100%"
                            textAlign="left"
                        >
                            Tools
                        </Text>
                        <Button
                            // leftIcon={<MdAdd style={{ marginRight: "-4px" }} />}
                            colorScheme="brand"
                            size="sm"
                            borderRadius="4px"
                            variant="solid"
                            onClick={handleCreateTool}
                        >
                            Create
                        </Button>

                    </Flex>

                    <VStack spacing={3} align="stretch" maxHeight={{ base: "100%", lg: "64vh" }} overflowY="auto">


                        {tools.map((tool) => {
                            console.log(" {tools.map ~ tool:", tool)
                            const isActive = selectedTool?.id === tool.id;
                            return (
                                <Flex
                                    key={tool.id}
                                    justify="space-between"
                                    align="center"
                                    p={3}
                                    position="relative"
                                    // bg={isActive ? 'brand.500' : 'white'}
                                    bg={isActive ? 'white' : 'white'}
                                    borderRadius="md"
                                    border="1px solid"
                                    role="group"
                                    borderColor={isActive ? 'brand.500' : 'gray.200'}
                                    borderWidth={isActive ? 2 : 1}
                                    // _hover={{
                                    //     bg: isActive ? 'brand.500' : 'gray.100',
                                    //     borderColor: isActive ? 'brand.500' : 'gray.300',
                                    //     cursor: 'pointer'
                                    // }}
                                    _hover={{
                                        bg: isActive ? 'white' : 'gray.100',
                                        borderColor: isActive ? 'brand.500' : 'gray.300',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => handleSelectTool(tool)}
                                >
                                    <Box maxW="100%">
                                        <Text
                                            fontSize="sm"
                                            fontWeight="bold"
                                            // color={isActive ? 'white' : textColor}
                                            color={textColor}
                                            isTruncated
                                            maxW="100%"
                                        >
                                            {tool.name}
                                        </Text>
                                        <Text
                                            fontSize="sm"
                                            // color={isActive ? 'white' : 'gray.500'}
                                            color={textColor}
                                            isTruncated
                                            maxW="100%"
                                        >
                                            {tool?.tool?.function?.description}
                                        </Text>
                                    </Box>

                                    <IconButton
                                        icon={<MdDelete style={{ marginLeft: "-0.5px" }} />}
                                        aria-label="Delete Tool"
                                        size="xs"
                                        colorScheme='red'
                                        variant="solid"
                                        // bg="gray.200"
                                        // color="gray.600"            // normal background
                                        // _hover={{ bg: 'gray.00' }} // hover background
                                        // _active={{ bg: 'gray.400' }} // active (click) background
                                        // onClick={(e) => {
                                        //     e.stopPropagation();
                                        //     handleDeleteTool(tool.id);
                                        // }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            openDeleteModal(tool);
                                        }}

                                        opacity={0}
                                        position="absolute"
                                        top="50%"
                                        right="8px"
                                        transform="translate(0%,-50%)"
                                        _groupHover={{ opacity: 1 }}
                                        transition="opacity 0.2s ease"
                                    />


                                    {/* <IconButton
                                    icon={<MdEdit />}
                                    size="xs"
                                    variant="solid"
                                    colorScheme="brand"
                                    aria-label="Edit Tool"
                                    _hover={{ bg: 'brand.400', color: 'white' }}
                                /> */}
                                </Flex>
                            );
                        })}

                    </VStack>
                </Box>

                {/* Right panel - 70% */}
                <Box
                    w={{ base: "100%", lg: "70%" }}
                    p={4}
                    bg="white"
                    borderRadius="md"
                    boxShadow="xs"
                >
                    {mode ? (
                        <ToolForm selectedTool={selectedTool} mode={mode} onSubmit={handleSubmit} onDelete={handleDeleteTool} openDeleteModal={openDeleteModal} />
                    ) : (
                        <Text color="gray.500" mt={8} fontSize="lg">
                            Select a tool to edit or click "Add" to create a new one.
                        </Text>
                    )}
                </Box>
            </Flex>
            <DeleteModal
                isOpen={isDeleteModalOpen}
                onClose={closeDeleteModal}
                onDelete={confirmDelete}
                selectedItem={itemToDelete?.name}
            />

        </Card>
    );
}
